import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BundleCard } from './BundleCard';
import { useOfferTimer } from '../../contexts/OfferTimerContext';
import { bundleBonuses, bundleBonusesTitle, bundleMainProduct } from '../../data/babyShowerBundle';
import { discountPercent, formatArs, pricing, pricingFlags } from '../../data/babyShowerPricing';
const bundleCopy = {
  eyebrow: 'Todo lo que recibís',
  title: '¡Los juegos para tu Baby Shower y 4 regalos para sumar todavía más diversión!'
};
export function Bundle() {
  const {
    expired
  } = useOfferTimer();
  return <section id="csomag" aria-labelledby="bundle-title" className="scroll-mt-14 bg-[#FAF0E7] py-11 md:py-16" data-id="element-14" data-mp="2b9k8xrvljg18">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-15" data-mp="21dgyzzui6d3q">
        <header className="mx-auto max-w-2xl text-center" data-id="element-16" data-mp="21c5w028vt9do">
          <p className="inline-flex max-w-full items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-17" data-mp="kyz5y14akpcs">
            {bundleCopy.eyebrow}
          </p>
          <h2 id="bundle-title" className="mx-auto mt-4 max-w-[24ch] font-display text-[1.65rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[2.1rem] md:text-[2.4rem]" data-id="element-18" data-mp="ce16t7jp440g">
            {bundleCopy.title}
          </h2>
        </header>

        {/* Producto principal */}
        <article className="mt-8 grid gap-5 rounded-[2rem] border-2 border-[#F5B4C9] bg-white p-3 shadow-[0_18px_40px_-26px_rgba(231,77,122,0.55)] md:mt-10 md:grid-cols-[1fr_1fr] md:items-center md:gap-8 md:p-4" data-id="element-19" data-mp="gfv4d6ylgrwe">
          <img src={bundleMainProduct.image} alt={`Portada: ${bundleMainProduct.title}`} data-slot="main-product-mockup" className="mx-auto h-auto w-full max-w-md rounded-[1.25rem]" data-id="element-20" data-mp="142uxjz7q4zoa" />
          <div className="px-2 pb-3 md:px-0 md:py-4 md:pr-6" data-id="element-21" data-mp="103vktsfr3yma">
            <span className="inline-block rounded-full bg-[#F5B4C9] px-3.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#4A3A35] sm:text-[12px]" data-id="element-22" data-mp="1e1sheou7g50y">
              {bundleMainProduct.badge}
            </span>
            <h3 className="mt-3 font-display text-[1.4rem] font-extrabold leading-tight tracking-[-0.01em] text-[#4A3A35] md:text-[1.75rem]" data-id="element-23" data-mp="6mouwparpr20">
              {bundleMainProduct.title}
            </h3>
            <p className="mt-2.5 text-[15px] leading-relaxed text-body md:text-[16px]" data-id="element-24" data-mp="fnd9pm7zjvfy">{bundleMainProduct.description}</p>
            <ul className="mt-4 space-y-2" data-id="element-25" data-mp="pfj93h0khf56">
              {bundleMainProduct.benefits.map(b => <li key={b} className="flex items-start gap-2.5 text-[15px] leading-snug text-[#4A3A35] md:text-[16px]" data-id="element-26" data-mp="phlvlr2igq55">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#FDE3EC] text-[#E74D7A]" aria-hidden="true" data-id="element-27" data-mp="yg7drl42m35e">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-28" data-mp="13e966wndzetj" />
                  </span>
                  {b}
                </li>)}
            </ul>

            {/* Presentación de precio (se retira al vencer la oferta) */}
            {!expired && <div className="mt-5 rounded-2xl bg-[#FEEAF1] px-4 py-3.5" data-id="element-29" data-mp="2xmmgsl0cuarg">
              {pricingFlags.showListPrice && <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[14px] text-body" data-id="element-30" data-mp="2swfq8fma8g6k">
                  Precio de lista:
                  <s className="font-semibold text-[#8B6B55] decoration-[#E74D7A] decoration-2" data-id="element-31" data-mp="2nxutwra5igne">{formatArs(pricing.listPrice)}</s>
                  {pricingFlags.showDiscountBadge && <span className="rounded-full bg-[#15ADA8] px-2 py-0.5 text-[11px] font-extrabold uppercase tracking-[0.04em] text-white" data-id="element-32" data-mp="3gma5f3u2qgtz">
                      {discountPercent}% off
                    </span>}
                </p>}
              <p className="mt-1 flex items-baseline gap-2" data-id="element-33" data-mp="36m9ht5p69ejz">
                <span className="text-[14px] font-semibold text-[#4A3A35]" data-id="element-34" data-mp="32m92liu90zbv">Precio de oferta:</span>
                <span className="font-display text-[2.1rem] font-extrabold leading-none tracking-[-0.02em] text-[#C2335F] md:text-[2.4rem]" data-id="element-35" data-mp="1v85s4bpmackq">
                  {formatArs(pricing.offerPrice)}
                </span>
              </p>
            </div>}
          </div>
        </article>

        {/* 4 bonos de regalo, todos con el mismo diseño */}
        {bundleBonuses.length > 0 && <div className="mt-10 md:mt-12" data-id="element-36" data-mp="3jwbaoiwqnx7a">
            <div className="flex items-center justify-center gap-1.5" aria-hidden="true" data-id="element-37" data-mp="3563uk9u7eq9r">
              <span className="h-1.5 w-1.5 rounded-full bg-[#93D1CE]" data-id="element-38" data-mp="3a3vwzxsh5us7" />
              <span className="h-1.5 w-6 rounded-full bg-[#F5B4C9]" data-id="element-39" data-mp="3a22r4kporel9" />
              <span className="h-1.5 w-1.5 rounded-full bg-[#93D1CE]" data-id="element-40" data-mp="1pewlc8osovp" />
            </div>
            <h3 className="mx-auto mt-3 max-w-[22ch] text-center font-display text-[1.4rem] font-extrabold leading-tight tracking-[-0.01em] text-[#4A3A35] [text-wrap:balance] sm:text-[1.75rem]" data-id="element-41" data-mp="6n6nc2xli4yb">
              {bundleBonusesTitle}
            </h3>
            <ul className="mx-auto mt-6 grid max-w-4xl gap-3 md:grid-cols-2 md:gap-4" data-id="element-42" data-mp="2de6715v1i15a">
              {bundleBonuses.map((b, i) => <li key={b.title} data-id="element-43" data-mp="2hg9jnxtg3bs5" data-mpi={i}>
                  <BundleCard item={b} slot={`bonus-${i + 1}`} showPromo={!expired} data-id="element-44" data-mp="2hhb60yfwvkp6" />
                </li>)}
            </ul>
          </div>}
      </div>
    </section>;
}